module.exports = __webpack_public_path__ + "static/media/loja2b.240e875f.jpg";